module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "page-top-header",
    attrs: {
      "id": "pageStickyHeader"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "h-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('timeline')
      }
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('markets')
      }
    }
  }, [_vm._v("Markets")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('trending')
      }
    }
  }, [_vm._v("Trending")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "border": "indigo solid"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "border": "rgb(26, 130, 0) solid"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', {
    staticStyle: {
      "border": "indigo solid"
    }
  }, [(_vm.menu_view.timeline) ? _c('div', {
    staticClass: "row card-box-o"
  }, _vm._l((_vm.market.business_markets), function(user, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + user.business_username
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-circle"
    }, [_c('img', {
      attrs: {
        "src": user.business_banner_image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(user.business_name)), _c('br'), _c('span', [_vm._v("@" + _vm._s(user.business_username))])])]), _vm._v(" "), _vm._m(1, true)])])])
  })) : _vm._e(), _vm._v(" "), (_vm.menu_view.markets) ? _c('div', {
    staticClass: "row card-box-o"
  }, _vm._l((_vm.market_groups), function(group, index) {
    return _c('div', {
      staticClass: "card card-01"
    }, [_c('h5', [_vm._v(_vm._s(group.business_market_group_name))]), _vm._v(" "), _vm._l((group.businesses_in_business_market_group), function(business, index) {
      return _c('div', _vm._l((business.business_market_group_business_products), function(product, index2) {
        return _c('div', {
          staticClass: "card card-01 timeline-user-card"
        }, [_c('a', {
          staticStyle: {
            "text-decoration": "none",
            "color": "inherit"
          },
          attrs: {
            "href": '/' + product.product_business_ownername + '/' + product.product_url_name
          }
        }, [_vm._m(2, true), _vm._v(" "), _c('div', {
          staticClass: "card-left"
        }, [_c('div', {
          staticClass: "card-avatar-square"
        }, [(product.product_images[0]) ? _c('img', {
          attrs: {
            "src": product.product_images[0].product_image
          }
        }) : _c('img', {
          attrs: {
            "src": "/static/assets/images/dummy-image.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "card-right"
        }, [_c('div', {
          staticClass: "card-arm-line"
        }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])]), _vm._v(" "), _vm._m(3, true)])])])
      }))
    })], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.menu_view.trending) ? _c('div', {
    staticClass: "row card-box-o"
  }, _vm._l((_vm.market_trending), function(product, index) {
    return _c('div', {
      staticClass: "card card-01 timeline-user-card"
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + product.product_business_ownername + '/' + product.product_url_name
      }
    }, [_c('span', {
      staticClass: "card-thumb-up-left"
    }, [_vm._v("@" + _vm._s(product.product_business_ownername))]), _vm._v(" "), _c('div', {
      staticClass: "card-left"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(product.product_images[0]) ? _c('img', {
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-right"
    }, [_c('div', {
      staticClass: "card-arm-line"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price) + " - ₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])]), _vm._v(" "), _vm._m(4, true)])])])
  })) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-thumb-up-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-thumb-up-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-certificate"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-arm-alt-bottom"
  }, [_c('div', {
    staticClass: "card-analytics"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-tag"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9aa06554"}!./src/pages/Buzz/template.html
// module id = 616
// module chunks = 0